import { useState, useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { styled } from '@mui/styles';
import { useSelector } from 'react-redux';
import { UserTypeEnum } from '@utils/constants';
import DashboardNavbar from './DashboardNavbar';
import AdminSidebar from './AdminSidebar';

const DashboardLayoutRoot = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  width: '100%'
}));

const DashboardLayoutWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  paddingTop: 64,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 256
  }
}));

const DashboardLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const DashboardLayoutContent = styled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto'
});

const AdminLayout = () => {
  const { isUserLoggedIn, user, merchant } = useSelector((state) => state.auth);
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  useEffect(() => {
    if (isUserLoggedIn && !!user && user.userTypeId === UserTypeEnum.SuperAdmin) {
      // Load SA data
    }
  }, [isUserLoggedIn, user]);

  if (!isUserLoggedIn) {
    return <Navigate to="/login" />;
  }

  if (!!user && user.userTypeId !== UserTypeEnum.SuperAdmin) {
    return <Navigate to="/404" />;
  }

  return (
    <DashboardLayoutRoot>
      <DashboardNavbar name={merchant?.merchantName} onMobileNavOpen={() => setMobileNavOpen(true)} />
      <AdminSidebar
        name={merchant?.merchantName}
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            <Outlet />
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default AdminLayout;
